/** Default Appwrite team that may open the admin console. */
export const DEFAULT_ADMINS_TEAM_ID = 'admins';

/** Full console access. Existing memberships already use this Appwrite team role. */
export const STAFF_ROLE_OWNER = 'owner';

/** Console access limited to publishing articles. */
export const STAFF_ROLE_AUTHOR = 'author';

export type StaffRole = typeof STAFF_ROLE_OWNER | typeof STAFF_ROLE_AUTHOR;

export function staffRoleFromMembershipRoles(roles: string[]): StaffRole {
    const set = new Set(roles.map((role) => role.trim().toLowerCase()));
    if (set.has(STAFF_ROLE_OWNER) || set.has('admin')) {
        return STAFF_ROLE_OWNER;
    }
    if (set.has(STAFF_ROLE_AUTHOR)) {
        return STAFF_ROLE_AUTHOR;
    }
    // Confirmed team members with empty or unknown roles keep full access.
    return STAFF_ROLE_OWNER;
}

export function staffRoleLabel(role: StaffRole): string {
    return role === STAFF_ROLE_AUTHOR ? 'כותב' : 'מנהל';
}

export function isFullAdminRole(role: StaffRole | null | undefined): boolean {
    return role === STAFF_ROLE_OWNER;
}

export function staffAdminHomePath(role: StaffRole | null | undefined): '/admin' | '/admin/articles' {
    return role === STAFF_ROLE_AUTHOR ? '/admin/articles' : '/admin';
}

export function isAuthorAllowedAdminPath(pathname: string): boolean {
    if (pathname === '/admin/forbidden') return true;
    return pathname === '/admin/articles' || pathname.startsWith('/admin/articles/');
}
